<template>
  <h1>{{ tn("h1Heading") }}</h1>
  <div class="mb">
    <h2 class="mb">{{ tn("notification") }}</h2>
    <div>
      <svg-icon-component icon="webroot-logo" class="mb" />
      &nbsp;
      <svg-icon-component icon="logo-allstate" class="mb" />
    </div>
    <p>
      <strong>{{ tn("action") }}</strong>
    </p>
    <p>{{ tn("summaryText") }}</p>
  </div>
  <div class="mb">
    <button id="btn-learnMore" class="btn-outline-primary" @click="learnMore()">
      {{ tn("learnMore") }}
    </button>
  </div>
  <i18n-t keypath="AllstateNotPurchasedComponent.notes" tag="p" class="mt mb text-grey" scope="global">
    <template #downloads>
      <button id="btn-downloads" class="inline-btn-link" @click="goToDownloads()">{{ tn("downloads") }}</button>
    </template>
  </i18n-t>
</template>
<script lang="ts">
import { defineComponent, onBeforeMount } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { getUrl } from "@/common/getUrl";

import SvgIconComponent from "@/components/shared/SvgIcon/SvgIcon.vue";
import { useRouter } from "vue-router";

const componentName = "AllstateNotPurchasedComponent";

export default defineComponent({
  name: componentName,
  components: {
    SvgIconComponent,
  },
  setup() {
    logEvent("created", componentName);
    const router = useRouter();

    function tn(v: string, params?: Record<string, unknown>): string {
      return t(`${componentName}.${v}`, params);
    }

    function learnMore() {
      window.location.href = getUrl("WEBROOT_LEARN_MORE");
    }

    function goToDownloads() {
      router.push("/downloads");
    }

    onBeforeMount(async () => {
      logEvent("mounting", componentName);
    });

    //Expose to template
    return {
      tn,
      learnMore,
      goToDownloads,
    };
  },
});
</script>

<style scoped lang="css">
@import "@/styles/variables.css";
</style>
